import React from "react";
import { Container, ContainerFluid } from "../components/Wrapper.js";
import Header from "../components/headers/Header.js";
import Footer from "../components/footers/Footer.js";
import Eseries from "../components/Eseries.js";

export default function CseriesPage(){
  return (
    <Container>
      <Header isActiveTab="3" />
      <ContainerFluid>
        <Eseries />
      </ContainerFluid>
      <ContainerFluid>
        <Footer />
      </ContainerFluid>
    </Container>
  );
};